import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {

  return (
    <>
      <div className="container-fluid text-light footer pt-5 mt-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            {/* Quick Links */}
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3 text-start">Quick Links</h4>
              <ul className="list-unstyled">
                <li className="d-flex align-items-center mb-2">
                  <img
                    width={15}
                    height={15}
                    className="me-2"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO3asQ0CMRAF0W2CE/TfCQkSEEFAOYMsLiNG+rvM6+BrLjjLrpL0E8AZuANbdQZc+Xi2HgMcgMc+5gWcqiscEwrLhMIyobBMKMukskwqy6SyTKppZbb9uLzcqqsRQ/j+tI7VjSNSWCKFJVJYIoUlUlgiBf4AhsASIZhQYlnH0inX05cRDwakP/EGHbXP3xCyjY8AAAAASUVORK5CYII="
                    alt="icon"
                  />
                  <Link className="text-white text-decoration-none" to="/">Home</Link>
                </li>
                <li className="d-flex align-items-center mb-2">
                  <img
                    width={15}
                    height={15}
                    className="me-2"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO3asQ0CMRAF0W2CE/TfCQkSEEFAOYMsLiNG+rvM6+BrLjjLrpL0E8AZuANbdQZc+Xi2HgMcgMc+5gWcqiscEwrLhMIyobBMKMukskwqy6SyTKppZbb9uLzcqqsRQ/j+tI7VjSNSWCKFJVJYIoUlUlgiBf4AhsASIZhQYlnH0inX05cRDwakP/EGHbXP3xCyjY8AAAAASUVORK5CYII="
                    alt="icon"
                  />
                  <a className="text-white text-decoration-none" href="/">About</a>
                </li>
                <li className="d-flex align-items-center mb-2">
                  <img
                    width={15}
                    height={15}
                    className="me-2"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO3asQ0CMRAF0W2CE/TfCQkSEEFAOYMsLiNG+rvM6+BrLjjLrpL0E8AZuANbdQZc+Xi2HgMcgMc+5gWcqiscEwrLhMIyobBMKMukskwqy6SyTKppZbb9uLzcqqsRQ/j+tI7VjSNSWCKFJVJYIoUlUlgiBf4AhsASIZhQYlnH0inX05cRDwakP/EGHbXP3xCyjY8AAAAASUVORK5CYII="
                    alt="icon"
                  />
          <a className="text-white text-decoration-none" href="/">Courses</a>
                </li>
                <li className="d-flex align-items-center mb-2">
                  <img
                    width={15}
                    height={15}
                    className="me-2"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO3asQ0CMRAF0W2CE/TfCQkSEEFAOYMsLiNG+rvM6+BrLjjLrpL0E8AZuANbdQZc+Xi2HgMcgMc+5gWcqiscEwrLhMIyobBMKMukskwqy6SyTKppZbb9uLzcqqsRQ/j+tI7VjSNSWCKFJVJYIoUlUlgiBf4AhsASIZhQYlnH0inX05cRDwakP/EGHbXP3xCyjY8AAAAASUVORK5CYII="
                    alt="icon"
                  />
          <a className="text-white text-decoration-none" href="/">Contact</a>
                </li>
                <li className="d-flex align-items-center mb-2">
                  <img
                    width={15}
                    height={15}
                    className="me-2"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO3asQ0CMRAF0W2CE/TfCQkSEEFAOYMsLiNG+rvM6+BrLjjLrpL0E8AZuANbdQZc+Xi2HgMcgMc+5gWcqiscEwrLhMIyobBMKMukskwqy6SyTKppZbb9uLzcqqsRQ/j+tI7VjSNSWCKFJVJYIoUlUlgiBf4AhsASIZhQYlnH0inX05cRDwakP/EGHbXP3xCyjY8AAAAASUVORK5CYII="
                    alt="icon"
                  />
                <a className="text-white text-decoration-none" href="/">Testimonials</a>
                </li>
              </ul>
            </div>

         

            {/* Courses */}
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3 text-start">Courses</h4>
              <ul className="list-unstyled">
                <li className="d-flex align-items-center mb-2">
                  <img
                    width={15}
                    height={15}
                    className="me-2"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO3asQ0CMRAF0W2CE/TfCQkSEEFAOYMsLiNG+rvM6+BrLjjLrpL0E8AZuANbdQZc+Xi2HgMcgMc+5gWcqiscEwrLhMIyobBMKMukskwqy6SyTKppZbb9uLzcqqsRQ/j+tI7VjSNSWCKFJVJYIoUlUlgiBf4AhsASIZhQYlnH0inX05cRDwakP/EGHbXP3xCyjY8AAAAASUVORK5CYII="
                    alt="icon"
                  />
                  <Link className="text-white text-decoration-none" to="/">Embedded System</Link>
                </li>
                <li className="d-flex align-items-center mb-2">
                  <img
                    width={15}
                    height={15}
                    className="me-2"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO3asQ0CMRAF0W2CE/TfCQkSEEFAOYMsLiNG+rvM6+BrLjjLrpL0E8AZuANbdQZc+Xi2HgMcgMc+5gWcqiscEwrLhMIyobBMKMukskwqy6SyTKppZbb9uLzcqqsRQ/j+tI7VjSNSWCKFJVJYIoUlUlgiBf4AhsASIZhQYlnH0inX05cRDwakP/EGHbXP3xCyjY8AAAAASUVORK5CYII="
                    alt="icon"
                  />
                  <Link className="text-white text-decoration-none" to="/">Mobile App Development</Link>
                </li>
                <li className="d-flex align-items-center mb-2">
                  <img
                    width={15}
                    height={15}
                    className="me-2"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO3asQ0CMRAF0W2CE/TfCQkSEEFAOYMsLiNG+rvM6+BrLjjLrpL0E8AZuANbdQZc+Xi2HgMcgMc+5gWcqiscEwrLhMIyobBMKMukskwqy6SyTKppZbb9uLzcqqsRQ/j+tI7VjSNSWCKFJVJYIoUlUlgiBf4AhsASIZhQYlnH0inX05cRDwakP/EGHbXP3xCyjY8AAAAASUVORK5CYII="
                    alt="icon"
                  />
                  <Link className="text-white text-decoration-none" to="/">Full Stack Development</Link>
                </li>
                <li className="d-flex align-items-center mb-2">
                  <img
                    width={15}
                    height={15}
                    className="me-2"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO3asQ0CMRAF0W2CE/TfCQkSEEFAOYMsLiNG+rvM6+BrLjjLrpL0E8AZuANbdQZc+Xi2HgMcgMc+5gWcqiscEwrLhMIyobBMKMukskwqy6SyTKppZbb9uLzcqqsRQ/j+tI7VjSNSWCKFJVJYIoUlUlgiBf4AhsASIZhQYlnH0inX05cRDwakP/EGHbXP3xCyjY8AAAAASUVORK5CYII="
                    alt="icon"
                  />
                  <Link className="text-white text-decoration-none" to="/">IoT</Link>
                </li>
              </ul>
            </div>
   {/* Contact Info */}
   <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3 text-start">Contact</h4>
             
              <p className="mb-2 text-white text-start">
                <i className="fa fa-phone-alt me-2"></i><a href="tel:+916284636956" style={{textDecoration:"none",color:"#fff"}}>+91 6284-636956</a>
              </p>
              <p className="mb-2 text-white text-start">
                <i className="fa fa-envelope me-2"></i><a href="mailto:info@codermonk.in" style={{textDecoration:"none",color:"#fff"}}>info@codermonk.in</a>
              </p>
              <div className="d-flex gap-3 mt-3">
                <Link className="btn btn-outline-light" href="/"><i className="fab fa-twitter"></i></Link>
                <Link className="btn btn-outline-light" href="/"><i className="fab fa-facebook-f"></i></Link>
                <Link className="btn btn-outline-light" href="/"><i className="fab fa-youtube"></i></Link>
                <Link className="btn btn-outline-light" href="/"><i className="fab fa-linkedin-in"></i></Link>
              </div>
            </div>
            {/* Location */}
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3 text-start">Location</h4>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.4728947145964!2d75.58318561066835!3d31.345927155633603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5bde4b978ac5%3A0xe6b30ccf89446f33!2sDigitalMonk!5e0!3m2!1sen!2sin!4v1737619055819!5m2!1sen!2sin"
                style={{ border: 0, width: "100%", height: "170px" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
               <p className="mt-2">
              2nd Floor, Tanda Rd, above Luvy Makeover, near Domino's, Doaba
              Chowk, Aman Nagar, Jalandhar, Punjab 144004
            </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
